export const mapEventPropToEvent = (
  event,
) => event.substring(2).toLocaleLowerCase();
